import { PROJECT_STATUS } from "@/enums";

export const calculateCanUserModifyProjectStatus = (
  projectStatus?: string,
): boolean =>
  projectStatus !== PROJECT_STATUS.project.onHold.id &&
  projectStatus !== PROJECT_STATUS.project.canceled.id &&
  projectStatus !== PROJECT_STATUS.project.complete.id;
